import React, { useEffect, useState } from 'react';
import { DotLottie } from 'components/DotLottie/DotLottie';
import loadingAnimation from 'assets/lotties/SignupLoading.lottie';
import { Box, Stack, styled, Typography } from '@mui/material';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';

interface LoadingStepProps {
  messages: string[];
}

const MESSAGE_ANIMATION_INTERVAL = 3000;
const ANIMATION_HEIGHT = 457;

const AnimatedTypography = styled(Typography)`
  @keyframes slideIn {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  animation: slideIn 0.5s ease-out;
`;

export const LoadingStep = ({ messages }: LoadingStepProps) => {
  const [messageIndex, setMessageIndex] = useState(0);
  const { isMobile } = useDeviceType();

  // Cycle between messages if there are multiple
  useEffect(() => {
    if (messages.length <= 1) return undefined;

    const interval = setInterval(() => {
      setMessageIndex((current) => (current + 1) % messages.length);
    }, MESSAGE_ANIMATION_INTERVAL);
    return () => clearInterval(interval);
  }, [messages]);

  return (
    <Stack className="loading-screen" spacing={2} justifyContent="center" alignItems="center">
      <AnimatedTypography
        key={messageIndex}
        fontWeight={500}
        variant={isMobile ? 'callout' : 'title3'}
        color="grey.600"
        textTransform="uppercase"
        className="loading-screen__message"
      >
        {messages[messageIndex]}
      </AnimatedTypography>
      <Box height={ANIMATION_HEIGHT} className="loading-screen__animation">
        <DotLottie src={loadingAnimation} autoplay loop />
      </Box>
    </Stack>
  );
};
